import { render, staticRenderFns } from "./EventInsights.vue?vue&type=template&id=faf7d7f2&scoped=true"
import script from "./EventInsights.vue?vue&type=script&lang=js"
export * from "./EventInsights.vue?vue&type=script&lang=js"
import style0 from "./EventInsights.vue?vue&type=style&index=0&id=faf7d7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf7d7f2",
  null
  
)

export default component.exports